import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, type Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "adminList" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
